import useSearchResultsSelectedFilters from './useSearchResultsSelectedFilters.js';
/**
 * @desc: groups facet ids with it's own values.
 */
const useSearchResultsSelectedFacets = () => {
    const selectedFacets = useSearchResultsSelectedFilters();
    const groupedSelectedFacets = selectedFacets.reduce((accumulator, currentFacet) => {
        if (!accumulator[currentFacet.facetId]) {
            accumulator[currentFacet.facetId] = {
                values: [],
                label: currentFacet.facetLabel,
            };
        }
        accumulator[currentFacet.facetId].values.push(currentFacet);
        return accumulator;
    }, {});
    const results = [];
    const facetTypes = Object.keys(groupedSelectedFacets);
    facetTypes.forEach((f) => {
        results.push({
            id: f,
            values: groupedSelectedFacets[f].values,
            name: groupedSelectedFacets[f].label,
        });
    });
    return results;
};
export default useSearchResultsSelectedFacets;
